/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { InlineMessage, Link, Group, Copy, Title, UnsavedMessage, PopupMessage } from '@insticator/insticator-ui'; // iui-materials
import PreferSelector from 'pages/dashboard/account/paymentinfo/enterinformation/preferselector/preferselector_container';
import PaymentInfoCTAs from 'pages/dashboard/account/paymentinfo/paymentInfoCTAs/paymentInfoCTAs_container';
// types
import WireTransfer from 'pages/dashboard/account/paymentinfo/selectmethod/wiretransfer/wiretransfer_container';
import Paypal from 'pages/dashboard/account/paymentinfo/selectmethod/paypal/paypal_container';
import DirectDeposit from 'pages/dashboard/account/paymentinfo/selectmethod/directdeposit/directdeposit_container';
import Check from "pages/dashboard/account/paymentinfo/selectmethod/check/check_container";
// utils
import { createFormDataBlobWithFile, isFormValid } from '@insticator/insticator-ui'; // iui-utils
import paymenttypemap from 'pages/dashboard/account/paymentinfo/paymenttypemap';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/account/paymentinfo/enterinformation/enterinformation_styles';



/* ========== ~~~~~~~~~~ ACCOUNT ENTER INFORMATION ~~~~~~~~~~ ========== */
class EnterInformation extends Component {
    constructor(props){
        super(props);
        this.state = {
            file: ''
        };
        this.saveClicked = false;
    }

    componentDidUpdate(prevPros){
        if(prevPros.selectedPaymentType !== this.props.selectedPaymentType){
            this.setState({file: ''});
        }
    }
    componentWillUnmount(){
        this.handleDiscard();
    }

    handleFileUpload = (file) => {
        this.setState({file})
    };
    handleDiscardFile = () => {
        this.setState({file: ''})
    };

    handleDiscard = () => {
        this.props.discardChanges(this.props.formName);
        this.props.setFormEditableState(this.props.formName, false)
    };

    handleSave = () => {
        this.props.invalidateForm(this.props.formName);
        if (!isFormValid(this.props.fields)) return;
        if (this.props.preferredPaymentType && !this.props.fields.preferredPayment.value) {
            this.props.displayModal(true, <PopupMessage
                                                type={'verify'}
                                                title={'Verify your preferred payment method'}
                                                body={<p>Your current preferred payment method is <strong>{paymenttypemap[this.props.preferredPaymentType]}</strong>. Do you want <strong>{paymenttypemap[this.props.selectedPaymentType]}</strong> to be your new preferred method?</p>}
                                                buttonPrimary={{ text: 'Yes, confirm new payment method', variant: 'action', action: () => this.postOrPutChanges(true) }}
                                                buttonSecondary={{ text: 'Save without changing preferred method', variant: 'system', action: () => this.postOrPutChanges(false) }}
                                            />);
        } else{
            this.postOrPutChanges();
        }
    };
    postOrPutChanges = (modalResponse) => {
        if (this.saveClicked) return;
        this.saveClicked = true;
        if (this.props.paymentUUID) {
            this.props.updatePaymentInformationWithValidation(this.getPaymentFormCallData(this.props.selectedPaymentType, modalResponse), this.props.selectedPaymentType, this.props.fields, this.props.paymentUUID, this.updatePaymentInfoSuccessCall, this.updatePaymentFailCall);
        } else {
            this.props.savePaymentInformationWithValidation(this.getPaymentFormCallData(this.props.selectedPaymentType, modalResponse), this.props.selectedPaymentType, this.props.fields, this.props.accountUUID, this.updatePaymentInfoSuccessCall, this.updatePaymentFailCall);
        }
    };
    //I am changing paymentType to NONE to prevent a paymentType that is already saved from being selected and saved againn
    updatePaymentInfoSuccessCall = () =>{
        this.props.getPaymentInformation(this.props.accountUUID);
        this.props.moveToPage('dashboard/account/paymentinfo/existingpayments');
        this.props.changePaymentType('NONE');
    };

    updatePaymentFailCall = () => {
      this.saveClicked = false;
    };

    handleNavBack = () => {
        let route = this.props.previousPage === 'dashboard/account/paymentinfo/selectmethod' ? this.props.previousPage : 'dashboard/account/paymentinfo/existingpayments';
        this.props.moveToPage(route);
        this.props.changePaymentType('NONE');
    };

    changeEditableState = ()=>this.props.setFormEditableState(this.props.formName, !this.props.editable);

    handleSecondaryAction = () => {
        this.props.editable ? this.props.displayModal(true, <UnsavedMessage primaryAction={this.handleNavBack} />) : this.handleNavBack();
    };

    getPaymentFormCallData = (formName, modalResponse) =>{

        switch (formName) {
            case 'CHECKS':
                return createFormDataBlobWithFile({
                    payTo: this.props.fields.payTo.value,
                    paymentStreetAddress: this.props.fields.paymentAddress.value,
                    city: this.props.fields.city.value,
                    state: this.props.fields.state.value,
                    zipCode: this.props.fields.zip.value,
                    country: this.props.fields.country.value,
                    w9Form: this.state.file,
                    preferredPayment: this.preferredPaymentHelper(modalResponse)
                });
            case 'WIRE':
                return createFormDataBlobWithFile({
                    businessType: this.props.fields.businessType.value,
                    bankName: this.props.fields.bankName.value,
                    accountName: this.props.fields.accountName.value,
                    bankStreetAddress: this.props.fields.bankAddress.value,
                    bankRegion: this.props.fields.bankState.value,
                    bankCountry: this.props.fields.bankCountry.value,
                    bankCity: this.props.fields.bankCity.value,
                    bankZipCode: this.props.fields.bankZip.value,
                    swift: this.props.fields.swift.value,
                    iban: this.props.fields.iban.value,
                    w8Form: this.state.file,
                    preferredPayment: this.preferredPaymentHelper(modalResponse)
                });
            case 'PAYPAL':
                return {
                    paypalUserName: this.props.fields.paypalUserName.value,
                    preferredPayment: this.preferredPaymentHelper(modalResponse)
                };
            case 'ACH':
            default:
                return createFormDataBlobWithFile({
                    bankAccountType: this.props.fields.bankAccountType.value,
                    bankName: this.props.fields.bankName.value,
                    accountName: this.props.fields.accountName.value,
                    routingCode: this.props.fields.routingNumber.value,
                    accountNumber: this.props.fields.accountNumber.value,
                    w9Form: this.state.file,
                    preferredPayment: this.preferredPaymentHelper(modalResponse)
                });
        }
    };

    preferredPaymentHelper = (modalResponse) => modalResponse ? true : this.props.preferredPaymentType === null ? true : this.props.fields.preferredPayment.value;

    renderPaymentType = () => {
        switch (this.props.selectedPaymentType) {
            case 'WIRE':
                return <WireTransfer handleFileDiscard={this.handleDiscardFile} handleFileUpload={this.handleFileUpload} />;
            case 'PAYPAL':
                return <Paypal />;
            case 'ACH':
                 return <DirectDeposit handleFileDiscard={this.handleDiscardFile} handleFileUpload={this.handleFileUpload} />;
            case 'CHECKS':
            default :
                 return <Check handleFileDiscard={this.handleDiscardFile} handleFileUpload={this.handleFileUpload} />;
        }
    };

    renderFormDownloadNotification = () => {
        if(this.props.fields.form) {
            if (this.props.fields.form.value.formLink && !this.props.editable) {
                if (this.props.formName === 'ACH' || this.props.formName === 'CHECKS') {
                    return <InlineMessage icon={`info-circle`}
                                         message={<p>Download your W9 Form <strong><Link type={'external'}
                                                                                      action={this.props.fields.form.value.formLink}
                                                                                      text={'here'}/></strong></p>}
                                         variant={`primary`} size={`half`}/>
                } else if (this.props.formName === 'WIRE') {
                    return <InlineMessage icon={`info-circle`} message={<p>Download
                        your {this.props.fields.businessType.value === `INTERNATIONAL_CORPORATION` ? `W-8BEN-E Form` : `W-8BEN Form`} Form <strong><Link
                           type={'external'} action={this.props.fields.form.value.formLink} text={'here'}/></strong>
                    </p>} variant={`primary`} size={`half`}/>
                }
            }
        }
    };

    displayEnterInfoTitle = () =>  `- ${paymenttypemap[this.props.selectedPaymentType]}`;
    render() {
        return(
            <div className={`enterinformation ${this.props.classes.enterinformation}`}>
                <Copy name={`page-copy`}>
                    <Title variant={'withctas'}>
                        <h2>Payment Method {this.displayEnterInfoTitle()} </h2>
                        <Group name={`controls`}>
                            <PaymentInfoCTAs secondaryButtonText={'Back'} secondaryAction={this.handleSecondaryAction} primaryVariant={this.props.editable ? 'action' : 'primary'} primaryButtonText={this.props.editable ? 'Save' : 'Edit this payment information'} primaryAction={this.props.editable ? this.handleSave : this.changeEditableState} />
                        </Group>
                    </Title>
                </Copy>
                <Group name={`payment-select`}>
                    <div className={`payment-method`}>
                        <InlineMessage icon={`exclamation-triangle`} message={`Minimum threshold for any payment is $${this.props.payoutThreshold}.00 USD`} variant={`neutral`} size={`half`} />
                        {this.renderFormDownloadNotification()}
                    </div>
                </Group>
                <Group name={`page-details`}>
                    {this.renderPaymentType()}
                    <PreferSelector editable={this.props.editable} />
                </Group>
            </div>
        );
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EnterInformation);
